import React from 'react'

var Success = React.createClass({
  render: function(){
    if(!this.props.message) return false
    return (
      <p className="alert alert-success" style={{display: 'block'}}><i className="fa fa-thumbs-up"></i> {this.props.message}</p>
    )
  }
})

module.exports = Success



// WEBPACK FOOTER //
// ./src/components/Success.jsx